import { IBusyState } from '../interfaces';


/**
 * Define métodos para modificar e informar el estado de trabajo para una componente
 */
export class BusyState implements IBusyState {

  /**
   * Propiedad utilizada para definir el estado de trabajo del componente
   */
  public state: boolean;

  constructor() {
    this.setBusyState(false);
  }

  public isBusy(): boolean {
    return this.state === true;
  }

  public setBusyState(value: boolean): Promise<any> {
    return new Promise((resolve) => {
      this.state = value;
      resolve(true);
    });
  }
}
